export default __webpack_public_path__ + "static/media/02.0b3598d4.png";